import React from "react";
import { TableColumns } from "../table-columns";

export const taskColumn = {
  title: "Task",
  key: "task",
  render: (item) => {
    return (
      <TableColumns.Task
        title={item.title}
        notes={item.notes}
        status={item.status}
      />
    );
  },
};

export const statusColumn = {
  title: "Status",
  key: "status",
  align: "center",
  render: (item) => {
    return <TableColumns.Status status={item.status} />;
  },
};

export const dueDateColumn = {
  title: "Due",
  key: "dueDateTime",
  dataIndex: "dueDateTime",
  render: (dueDateTime) => {
    return <TableColumns.Date dateTime={dueDateTime} />;
  },
  sorter: true,
  sortDirections: ["descend", "ascend"],
};

export const lastUpdatedColumn = {
  title: "Last Updated",
  key: "updatedAt",
  dataIndex: "updatedAt",
  render: (updatedAt) => {
    return <TableColumns.Date dateTime={updatedAt} />;
  },
  // sorter: true,
  // sortDirections: ["descend", "ascend"],
};

export const mobileColumns: any = [taskColumn];

export const desktopColumns: any = [
  taskColumn,
  dueDateColumn,
  lastUpdatedColumn,
  statusColumn,
  {
    title: "",
    key: "buttons",
    dataIndex: "buttons",
  },
];

export const closedColumns = [
  dueDateColumn,
  {
    title: "Summary",
    key: "summary",
    render: (item) => {
      return (
        <TableColumns.Task
          title={item.title}
          notes={item.notes}
          status={item.status}
        />
      );
    },
  },
  statusColumn,
];
